import { Component, computed, input } from '@angular/core';
import { JourneyPath } from '../../data/landing-content';

@Component({
  selector: 'app-path-card',
  standalone: true,
  host: {
    class: 'path-card',
    '[class.swapping]': 'swapping()',
  },
  template: `
    <div class="pc-head">
      <div>
        <div class="pc-label">Your path</div>
        <div class="pc-title">
          {{ path().from }}
          <span class="arrow">→</span>
          {{ path().to }}
        </div>
      </div>
      <div class="pc-badge"><span class="pc-dot"></span> Active</div>
    </div>

    <div class="pc-progress">
      <div class="pc-progress-fill" [style.width.%]="progressPercent()"></div>
    </div>

    <div class="pc-steps">
      @for (step of path().steps; track step; let i = $index) {
        <div
          class="pc-step"
          [class.done]="stepStatus(i) === 'done'"
          [class.active]="stepStatus(i) === 'active'"
        >
          <span class="mark">{{ stepMark(i) }}</span>
          <span class="txt">
            <span class="name">{{ step }}</span>
            <span class="status">{{ stepMeta(i) }}</span>
          </span>
        </div>
      }
    </div>

    <div class="pc-nudge">
      <span class="kai-tag">KΛI</span>
      <span class="nudge-text" [class.faded]="!nudgeVisible()">{{
        nudge()
      }}</span>
    </div>
  `,
  styleUrl: './path-card.component.scss',
})
export class PathCardComponent {
  path = input.required<JourneyPath>();
  activeStepIndex = input(0);
  nudge = input('');
  swapping = input(false);
  nudgeVisible = input(true);

  readonly progressPercent = computed(() => {
    const steps = this.path().steps.length;
    return steps > 0 ? (this.activeStepIndex() / steps) * 100 : 0;
  });

  stepStatus(index: number): 'done' | 'active' | 'upcoming' {
    const active = this.activeStepIndex();
    if (index < active) return 'done';
    if (index === active) return 'active';
    return 'upcoming';
  }

  stepMark(index: number): string | number {
    const status = this.stepStatus(index);
    if (status === 'done') return '✓';
    return index + 1;
  }

  stepMeta(index: number): string {
    const status = this.stepStatus(index);
    const isLast = index === this.path().steps.length - 1;
    if (status === 'done') return 'Completed';
    if (status === 'active') return 'In progress';
    return isLast ? 'Final project' : 'Up next';
  }
}
